/**
 * Nature's T-Booster purchase UX
 * - Loop purchase options: total on top, per-bottle below (subscribe + one-time)
 * - Hides Loop native prices so only one clean stack shows
 * - ATC button: "Add To Cart · $total"
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('TBoosterPurchaseUxData');
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  if (!data || !data.variants) return;

  var moneyFormat = data.moneyFormat || '${{amount}}';
  var WRAP_CLASS = 'tb-loop-price-wrap';
  var HIDDEN_CLASS = 'tb-loop-native-price--hidden';
  var HOST_CLASS = 'tb-loop-price-host';
  var observer = null;
  var updating = false;

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, moneyFormat);
    }
    var value = (Number(cents) / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(Number(cents) / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function getProductRoot() {
    return (
      document.querySelector('[data-section-type="product"]') ||
      document.querySelector('.product-single') ||
      document
    );
  }

  function getSelectedVariantId(root) {
    var select = root.querySelector('[data-product-select]');
    if (select && select.value) {
      return String(select.value);
    }
    return data.currentVariantId ? String(data.currentVariantId) : null;
  }

  function getVariantInfo(variantId) {
    if (!variantId) return null;
    return data.variants[String(variantId)] || null;
  }

  function isSubscribeSelected(root) {
    var selected = root.querySelector(
      '.loop-widget-purchase-option-selected[data-loop-widget-selling-plan-group], ' +
        '.loop-widget-purchase-option.loop-widget-purchase-option-selected[data-loop-widget-selling-plan-group]'
    );
    if (selected) return true;

    var oneTimeSelected = root.querySelector(
      '.loop-widget-purchase-option-selected:not([data-loop-widget-selling-plan-group])'
    );
    if (oneTimeSelected) return false;

    var sellingPlanInput = root.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value && String(sellingPlanInput.value) !== '0') {
      return true;
    }

    return false;
  }

  function isSubscribeOption(option) {
    if (!option) return false;
    if (option.hasAttribute('data-loop-widget-selling-plan-group')) return true;
    var text = (option.textContent || '').toLowerCase();
    return text.indexOf('subscribe') !== -1 || text.indexOf('selling plan') !== -1;
  }

  function isProtectedRegion(el) {
    if (!el || !el.closest) return false;
    if (el.classList && (el.classList.contains(WRAP_CLASS) || el.classList.contains(HOST_CLASS))) {
      return true;
    }
    // Never hide our injected pricing tree
    if (el.closest('.' + WRAP_CLASS) || el.closest('.' + HOST_CLASS + ' > .' + WRAP_CLASS)) {
      return true;
    }
    if (el.className && /(?:^|\s)tb-loop-/.test(String(el.className))) {
      return true;
    }
    return !!(
      el.closest('.loop-widget-spg-container') ||
      el.closest('.loop-widget-purchase-option-description-container') ||
      el.closest('.loop-widget-sp-selector') ||
      el.closest('.loop-widget-sp-selector-description') ||
      el.closest('.loop-widget-purchase-option-radio') ||
      el.closest('[class*="badge"]')
    );
  }

  function looksLikePriceNode(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains(WRAP_CLASS) || el.classList.contains(HOST_CLASS)) return false;
    if (el.className && /(?:^|\s)tb-loop-/.test(String(el.className))) return false;
    // Don't hide ancestors that contain our wrap
    if (el.querySelector && el.querySelector('.' + WRAP_CLASS)) return false;

    var className = el.className && String(el.className);
    if (className && /price|money|amount|strike|compare|discount/i.test(className)) {
      if (/label|title|radio|badge|benefit|description|selector/i.test(className)) return false;
      return true;
    }

    if (el.children.length === 0) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^\$?\s*[\d,]+(\.\d{2})?(\s*\/\s*\w+)?$/.test(text)) return true;
    }

    return false;
  }

  function hideNativePrices(option) {
    // Ensure our wrap/host stay visible even if previously hidden
    var wrap = option.querySelector('.' + WRAP_CLASS);
    var host = option.querySelector('.' + HOST_CLASS);
    if (wrap) wrap.classList.remove(HIDDEN_CLASS);
    if (host) host.classList.remove(HIDDEN_CLASS);

    var nodes = option.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (isProtectedRegion(el)) continue;
      if (!looksLikePriceNode(el)) continue;
      el.classList.add(HIDDEN_CLASS);
    }
  }

  /**
   * Layout:
   *   Total price
   *   per unit price
   * One-time: no sale/compare prices
   * Subscribe: show sale vs one-time compare
   */
  function buildPriceHtml(info, isSubscribe) {
    var unitSuffix = '/btl';
    var total = isSubscribe ? info.subscriptionPrice : info.total;
    var perBottle = isSubscribe ? info.subscriptionPerBottle : info.perBottle;
    var compareTotal = null;

    if (isSubscribe) {
      if (info.total > total) compareTotal = info.total;
    } else if (info.bottleCount > 1 && info.compareTotal && info.compareTotal > total) {
      compareTotal = info.compareTotal;
    }

    var html = '<div class="tb-loop-price">';

    html += '<div class="tb-loop-price__total">';
    if (compareTotal) {
      html +=
        '<span class="tb-loop-price__compare">' + formatMoney(compareTotal) + '</span> ';
    }
    html += '<span class="tb-loop-price__amount">' + formatMoney(total) + '</span>';
    html += '</div>';

    if (info.bottleCount > 1) {
      html +=
        '<div class="tb-loop-price__unit">' +
        '<span class="tb-loop-price__unit-amount">' +
        formatMoney(perBottle) +
        unitSuffix +
        '</span></div>';
    }

    html += '</div>';
    return html;
  }

  function findNativePriceAnchor(option) {
    var selectors = [
      '.loop-widget-purchase-option-price',
      '[class*="purchase-option-price"]',
      '[class*="option-price"]',
      '[class*="otp-price"]',
      '[class*="compare-at-price"]',
      '[class*="discounted-price"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var matches = option.querySelectorAll(selectors[i]);
      for (var j = 0; j < matches.length; j++) {
        var el = matches[j];
        if (isProtectedRegion(el)) continue;
        return el;
      }
    }
    return null;
  }

  function getPriceHost(option, anchor) {
    if (!anchor) return null;

    var parent = anchor.parentElement;
    if (!parent || parent === option) return anchor;

    // Prefer a dedicated price cluster parent (contains multiple price nodes, not the whole row)
    if (
      parent.querySelectorAll('[class*="price"], [class*="Price"]').length >= 1 &&
      !parent.querySelector('.loop-widget-purchase-option-radio') &&
      !parent.querySelector('.loop-widget-spg-container')
    ) {
      return parent;
    }

    return anchor;
  }

  function ensurePriceWrap(option) {
    var wrap = option.querySelector('.' + WRAP_CLASS);
    if (wrap) {
      if (wrap.parentElement) {
        wrap.parentElement.classList.add(HOST_CLASS);
        wrap.parentElement.classList.remove(HIDDEN_CLASS);
      }
      wrap.classList.remove(HIDDEN_CLASS);
      hideNativePrices(option);
      return wrap;
    }

    wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;

    var anchor = findNativePriceAnchor(option);
    var host = getPriceHost(option, anchor);

    if (host) {
      host.classList.add(HOST_CLASS);
      host.classList.remove(HIDDEN_CLASS);

      // Hide native siblings in the host, then mount our single stack
      Array.prototype.forEach.call(Array.prototype.slice.call(host.children), function (child) {
        if (child !== wrap) child.classList.add(HIDDEN_CLASS);
      });

      host.appendChild(wrap);
    } else {
      // Fallback: place at end of the option header area
      var header =
        option.querySelector('.loop-widget-purchase-option-label') ||
        option.querySelector('[class*="purchase-option-label"]') ||
        option;
      header.appendChild(wrap);
    }

    wrap.classList.remove(HIDDEN_CLASS);
    hideNativePrices(option);
    return wrap;
  }

  function enhancePurchaseOptions(root, info) {
    var options = root.querySelectorAll('.loop-widget-purchase-option');
    if (!options.length) return;

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      option.classList.add('tb-loop-option--enhanced');
      var wrap = ensurePriceWrap(option);
      wrap.innerHTML = buildPriceHtml(info, isSubscribeOption(option));
      hideNativePrices(option);
    }
  }

  function updateAddToCart(root, info) {
    var btnText = root.querySelector('[data-add-to-cart-text]');
    var btn = root.querySelector('[data-add-to-cart]');
    if (!btnText || !info) return;

    if (!info.available) {
      var sold = data.soldOutLabel || 'Sold Out';
      btnText.setAttribute('data-default-text', sold);
      btnText.textContent = sold;
      return;
    }

    var subscribe = isSubscribeSelected(root);
    var priceCents = subscribe ? info.subscriptionPrice : info.total;
    var label = (data.addToCartLabel || 'Add to cart') + ' · ' + formatMoney(priceCents);

    btnText.setAttribute('data-default-text', label);
    if (!btn || !btn.disabled) {
      btnText.textContent = label;
    }
  }

  function sync() {
    if (updating) return;
    updating = true;
    try {
      if (observer) observer.disconnect();
      var root = getProductRoot();
      var variantId = getSelectedVariantId(root);
      var info = getVariantInfo(variantId);
      if (info) {
        enhancePurchaseOptions(root, info);
        updateAddToCart(root, info);
      }
      observeLoop(root);
    } finally {
      updating = false;
    }
  }

  function observeLoop(root) {
    var loopContainer =
      root.querySelector('[id^="loop-widget-container-id-"]') ||
      root.querySelector('.loop-widget-purchase-options-container') ||
      root;

    if (observer) observer.disconnect();

    observer = new MutationObserver(function (mutations) {
      if (updating) return;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t && t.closest && t.closest('.' + WRAP_CLASS)) {
          continue;
        }
        window.requestAnimationFrame(sync);
        return;
      }
    });

    observer.observe(loopContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-loop-widget-selling-plan-group']
    });
  }

  function bindEvents(root) {
    root.addEventListener('variantChange', function () {
      window.requestAnimationFrame(sync);
    });

    root.addEventListener('change', function (evt) {
      var t = evt.target;
      if (!t) return;
      if (
        t.matches(
          '[data-variant-input], [data-product-select], input[name="selling_plan"], .loop-widget-purchase-option input'
        ) ||
        (t.closest && t.closest('.loop-widget-purchase-option'))
      ) {
        window.requestAnimationFrame(sync);
      }
    });

    root.addEventListener('click', function (evt) {
      var opt = evt.target && evt.target.closest && evt.target.closest('.loop-widget-purchase-option');
      if (opt) {
        window.setTimeout(sync, 50);
      }
    });
  }

  function init() {
    var root = getProductRoot();
    bindEvents(root);
    observeLoop(root);
    sync();
    window.setTimeout(sync, 300);
    window.setTimeout(sync, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
